export default __webpack_public_path__ + "static/media/logo-cyd-tec.5ea3e9cf.png";